import React, { Children } from "react";
import FormActions from "components/FormActions";
import ConfirmIconButton from "components/ConfirmIconButton";
import { useFormikContext } from "formik";
import classnames from "classnames";

const DEFAULT_CLASSES = {
  container: "flex flex-column flex-row-ns items-center-ns",
  titleWrapper: "flex w-100 items-center pb3 pb0-ns",
  actionsWrapper: "flex flex-row justify-end justify-start-ns"
};

const ActionHeader = ({ actions, placeholder, customClasses, children }) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const { values } = useFormikContext();
  const editMode = Boolean(values.id);

  const showValue = editMode;

  return (
    <div className={classes.container}>
      <div className={classes.titleWrapper}>
        {showValue && <div className="f3 fw6">{values.name}</div>}
      </div>
      <div
        className={classnames(classes.actionsWrapper, {
          "justify-between": editMode
        })}
      >
        <div className="flex flex-row">
          {children && (
            <div className="pr2 bn br-ns hairline-1 flex flex-row">
              {children}
            </div>
          )}
          {editMode && (
            <div
              className={classnames("pr2 bn br-ns hairline-1 flex flex-row", {
                pl2: children
              })}
            >
              {actions &&
                actions.map((action, actionIx) => (
                  <ConfirmIconButton key={actionIx} {...action}>
                    {action.children || null}
                  </ConfirmIconButton>
                ))}
            </div>
          )}
        </div>
        <div className="pl2">
          <FormActions theme="slim" />
        </div>
      </div>
    </div>
  );
};

export default ActionHeader;
